<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Kode bidang" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Kode"
                    label="Kode"
                    :error-messages="errors"
                    placeholder="Kode bidang"
                    v-model="form.Kode"
                    hide-details="auto"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </Validate>
                <Validate name="Nama bidang" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Nama"
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama bidang"
                    v-model="form.Nama"
                    dense
                    hide-details="auto"
                    outlined
                    required
                  ></v-text-field>
                </Validate>

                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Kode: "",
      Nama: ""
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app
    })
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/administration/bidang", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/bidang");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Bidang" : "Bidang Baru";
    }
  },
  async mounted() {
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/administration/bidang/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>